<template>
  <b-card>
    <h3>{{$t('MY_ACCOUNT.General_Title')}}</h3>
    <!-- form -->
    <!-- media -->
    <b-media no-body>
      <b-media-aside v-if="form.image_path">
        <b-link>
          <b-img ref="previewEl" rounded :src="form.image_path" height="80" />
        </b-link>
        <!--/ avatar -->
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75"
          @click="$refs.refInputEl.$el.click()"
        >
          {{$t('MY_ACCOUNT.General_Upload')}}
        </b-button>
        <b-form-file
          ref="refInputEl"
          v-model="profileFile"
          accept=".jpg, .jpeg, .png"
          :hidden="true"
          plain
          :placeholder="$t('MY_ACCOUNT.General_Upload_Placeholder')"
          :drop-placeholder="$t('MY_ACCOUNT.General_Upload_Drop_Placeholder')"
          :browse-text="$t('MY_ACCOUNT.General_Upload_Text')"
          @change="onChangeUserImage"
        />
        <!-- @input="inputImageRenderer" -->
        <!--/ upload button -->

        <!-- reset -->
        <b-button
          v-if="form.file || form.image_path"
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-danger"
          size="sm"
          class="mb-75 mr-75"
          @click="onRemoveImage"
        >
          {{$t('MY_ACCOUNT.General_Remove')}}
        </b-button>
        <!--/ reset -->
        <b-card-text>{{$t('MY_ACCOUNT.General_Upload_Text')}}</b-card-text>
      </b-media-body>
    </b-media>
    <!--/ media -->
    <hr>
    <!-- form -->
    <b-form class="form-user">
      <b-row>
        <b-col sm="6">
          <b-form-group :label="$t('MY_ACCOUNT.General_Email')" label-for="account-email">
            <b-form-input
              disabled
              v-model="form.email"
              name="email"
              :placeholder="$t('MY_ACCOUNT.General_Email')"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group :label="$t('MY_ACCOUNT.General_Name')" label-for="account-name">
            <b-form-input disabled v-model="form.name" :placeholder="$t('MY_ACCOUNT.General_Name')" name="name" />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group :label="$t('MY_ACCOUNT.General_Nickname')" label-for="account-nickname">
            <b-form-input maxlength="20" v-model="form.nickname" :placeholder="$t('MY_ACCOUNT.General_Nickname')" name="nickname" />
          </b-form-group>
        </b-col>
        
        <b-col sm="12">
          <b-form-group :label="$t('MY_ACCOUNT.General_Resume')" label-for="account-resume">
            <b-form-textarea
              id="resume"
              :placeholder="$t('MY_ACCOUNT.General_Resume')"
              rows="4"
              v-model="form.resume"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            size="sm"
            
            variant="primary"
            
            @click="onSubmit"
          >
            {{$t('MY_ACCOUNT.Save')}}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
  BFormTextarea,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import userService from "@/providers/userService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import localStorageHelper from '@/helpers/local-storage-helper';

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      profileFile: null,
      form: {
        _id: "",
        name: "",
        nickname: "",
        email: "",
        resume: "",
        image_path: "",
        file: null
      },
    };
  },
  created() {
    this.getUserDetail();
  },
  watch: {
  },
  methods: {
    onSubmit() {
      const formData = new FormData();
      formData.append("_id", this.form._id);
      formData.append("name", this.form.name);
      formData.append("nickname", this.form.nickname);
      formData.append("resume", this.form.resume);
      if (this.form.file) {
        formData.append("avatar", this.form.file);
      }

      userService
        .updateMyAccountGeneral(formData, new URLSearchParams())
        .then((data) => {
          // console.log(res);
          messagesNotifyHelper.updatedRecordNotify();
          if (data.image_path) {
            const currentUser = this.$store.state.auth.currentUser;
            currentUser.avatar = data.image_path;
            this.$store.dispatch("auth/updateCurrentUser", currentUser);
          }
        })
        .catch((err) => console.log(err));
    },
    getUserDetail() {
      const params = new URLSearchParams();
      // console.log('state current user: ',this.$store.state.auth.currentUser)
      // params.append("email", this.$store.state.auth.currentUser.email);
      userService
        .getUserDetails(localStorageHelper.getUserId(), params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.nickname = res.nickname;
          this.form.email = res.email;
          this.form.resume = res.resume;

          if (res.image_path) {
            this.form.image_path = res.image_path;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onRemoveImage() {
      this.profileFile = null;
      this.form.file = null;
      this.form.image_path = "";
    },
    onChangeUserImage(input) {
      // console.log("onChangeUserImage: ", input);
      const file = input.target.files[0];
      this.form.file = file;
      if (file) {
        this.form.image_path = URL.createObjectURL(file);
      } else {
        this.form.image_path = "";
      }
    },
    resetForm() {
      // this.optionsLocal = JSON.parse(JSON.stringify(this.generalData));
    },
  },
  setup() {
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>
